export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";